const jaJP = {
  gate: {
    title: 'エディタを使う前にログインしてください',
    hint: 'ログイン画面を自動で開きます。表示されない場合は右上のアカウントアイコンから開けます。',
  },
  editorDraft: {
    dialogTitle: '未保存のローカル下書きがあります',
    dialogHint:
      '前回の編集内容がこのブラウザにキャッシュされています。復元して編集を続けるか、破棄して現在の空のプロジェクトから始められます。（画面テクスチャなどのバイナリは再アップロードが必要です。）',
    restore: '下書きを復元',
    discard: '破棄',
    timeHint: '保存日時：{time}',
    restoredStub: 'ローカル下書きからプロジェクトを復元しました。',
    persistFailedTitle: 'ローカル下書きの保存を一時停止しました',
    persistFailedBody:
      'ブラウザの保存容量が不足している可能性があります。「プロジェクトを保存」から JSON を書き出すか、サイトデータを削除してから再度お試しください。',
  },
  nav: {
    home: 'ホーム',
    projects: 'プロジェクト',
    undo: '元に戻す',
    redo: 'やり直し',
    accountEntry: 'アカウント',
    marketingHome: 'ホーム',
    marketingTemplates: 'テンプレート',
    marketingTutorials: 'チュートリアル',
    marketingPricing: '料金',
    marketingContact: 'お問い合わせ',
    marketingConsult: '相談',
    lang: '言語を切り替え',
    mode: '作業モードを切り替え',
    modeDefault: '通常モード',
    modeEdit: '編集モード',
  },
  leftRail: {
    deviceLibrary: 'デバイスライブラリ',
    mockupType: 'Mockup タイプ',
    mockupCategory: 'Mockup カテゴリ',
    searchDevices: 'デバイスを検索',
    addSelected: '選択したデバイスをキャンバスに追加',
    add: '追加',
    editTemplate: 'テンプレートを編集',
    categoryPhone: 'スマートフォン',
    categoryTablet: 'タブレット',
    categoryLaptop: 'ノートPC',
    categoryWatch: 'ウォッチ',
    categoryOther: 'その他',
    tagImageVideo: '画像 / 動画',
    tagText: 'テキスト',
  },
  floatingTools: {
    toolbarAria: 'モデル変換ツール',
    moveAria: '現在のモデルを移動',
    rotateAria: '現在のモデルを回転',
    scaleAria: '現在のモデルを拡大縮小',
    moveTitle: '移動',
    rotateTitle: '回転',
    scaleTitle: '拡大縮小',
  },
  viewport: {
    ariaLabel: 'Three.js ビューポート',
  },
  brand: {
    logoAria: 'Animock',
  },
  timeline: {
    panelLabel: 'アニメーションタイムライン',
    addAnimation: 'アニメーションを追加',
    scaleControl: 'タイムライン拡大率',
    zoomOut: 'タイムラインを縮小',
    zoomIn: 'タイムラインを拡大',
    zoomSlider: 'タイムライン拡大率: 最小は全体表示、最大はおよそ 1 秒 300px',
    play: '再生',
    pause: '一時停止',
    current: '現在',
    seconds: '秒',
    time: '時間',
    totalTimelineSeconds: 'タイムライン総秒数',
    snap: 'スナップ',
    snapHint: 'クリップドラッグのスナップ秒数、0 で無効',
    list: 'リスト',
    tracks: 'タイムライン',
    layersAria: 'アニメーションレイヤー',
    layerListAria: 'アニメーションレイヤー一覧',
    empty: 'モデルがありません',
    layerSelected: '{name}、選択中',
    layerSelect: '{name} を選択',
    addAnimationLocked: 'レイヤーがロックされているため、アニメーションクリップを追加できません',
    addAnimationOutOfVisibility:
      '再生ヘッドが可視区間外のため、アニメーションクリップを追加できません',
    lockLayer: 'レイヤーをロック',
    unlockLayer: 'レイヤーのロックを解除',
    duplicateLayer: 'レイヤーを複製',
  },
  timelineTracks: {
    groupLabel: 'タイムライントラック。フォーカス中は矢印キーで再生ヘッドを微調整',
    laneAria: '{name} のアニメーショントラック',
    trimStart: 'クリップ開始をトリム',
    trimEnd: 'クリップ終了をトリム',
    visibilityStart: '可視区間の開始を調整',
    visibilityEnd: '可視区間の終了を調整',
    keyframeInClip: 'クリップ内 {seconds} 秒',
    emptyLane: 'アニメーション編集には Mockup を追加してください',
    playheadAria: '再生ヘッド。ドラッグでスクラブ',
  },
  lightingDock: {
    panelAria: 'ライティングと環境',
    title: '環境光',
    presetsAria: 'ライティング環境プリセット',
    presetAria: 'ライト: {label}',
    ambientStrength: '環境光の強さ',
    ambientValue: '環境光倍率 {value}',
  },
  inspectorPanel: {
    inspectorAria: 'インスペクター',
    tabsAria: 'インスペクタータブ',
    tabBasic: '基本情報',
    tabControls: 'Mockup コントロール',
  },
  inspectorScene: {
    title: 'シーン設定',
    description:
      '上部の幅と高さはプレビューキャンバスです。解像度プリセットと比率プリセットは独立した単一選択グループです。',
    previewDimsAria: 'プレビューキャンバス寸法',
    width: '幅',
    height: '高さ',
    resolutionPresets: '解像度プリセット',
    resolutionHint: '書き出し画像/動画のピクセルのみに影響し、比率選択は変更しません。現在の書き出しは約 {width}×{height} です。',
    resolution4kLifetimeOnly: '4K 解像度は永久会員のみ選択できます。',
    resolutionGroupAria: '解像度プリセット',
    ratioPresets: '比率プリセット',
    ratioHint: 'プレビューキャンバス比率と論理ピクセルを決定します。書き出しサイズは現在の解像度と比率で決まります。',
    ratioGroupAria: 'アスペクト比プリセット',
  },
  inspectorBackground: {
    title: '背景色',
    type: '種類',
    modeColor: 'カラー',
    modeGradient: 'グラデーション',
    modeTransparent: '透明',
    modeImage: '画像',
    hexColor: '16 進カラー',
    pickBackgroundColor: '背景色を選択',
    colorPresets: 'カラープリセット',
    solidPresetAria: '単色プリセット {value}',
    transparentHint: '透明背景はビューポートでチェッカーボード表示されます。',
    imageHint: '画像 1 枚を背景として使用（自動で中央に配置し、ビューポートを覆います）。',
    imagePick: '画像を選択',
    imageReplace: '画像を差し替え',
    imageClear: 'クリア',
    imageInvalidType: '画像ファイルのみ対応しています（PNG / JPG / WEBP など）。',
  },
  inspectorGradient: {
    templatesAria: 'グラデーションテンプレート',
    fallbackTemplateName: 'グラデーション {id}',
    customGradient: 'カスタムグラデーション',
    colorStopsAria: 'グラデーション色標',
    stopColorAria: '色標 {position}% の色',
    stopHexAria: '色標 {position}% の 16 進値',
    stopPositionAria: '{hex} の位置',
    removeStopAria: '色標 {hex} を削除',
    addColor: '色を追加',
  },
  inspectorExport: {
    title: '書き出し設定',
    frameRate: 'フレームレート',
    exportFormat: '書き出し形式',
    operation: '書き出し操作',
    exportImage: '画像を書き出し',
    exportVideo: '動画を書き出し',
    cancelExport: '書き出しを中止',
    videoMp4TransparentBlocked:
      '透明背景では MP4 を書き出せません（H.264 は Alpha 非対応）。フォーマットを WebM に切り替えてから書き出してください。',
    mp4UnsupportedTitle: '現在のブラウザー環境では 2K MP4 書き出しに対応していません',
    mp4UnsupportedBody:
      'お使いのブラウザー、システム、または GPU 環境では、この解像度での H.264 MP4 エンコードを完了できません。\n\n次をお試しください：\n1. 1K の MP4 で書き出す\n2. 2K のまま WebM に切り替える\n3. 最新の Chrome / Edge で再試行する',
    vp9AlphaLayerTitle: '透明動画を書き出せません',
    vp9AlphaLayerBody:
      'お使いのブラウザは WebM VP9（Alpha）に対応していません。透明背景をオフにするか、Chrome / Edge などで再試行してください。',
    layerToastDismissAria: '閉じる',
    loginRequired: '書き出しにはログインが必要です。',
    preflightInProgress: '書き出しを登録しています…',
    preflightFailed: '書き出し登録に失敗しました：{reason}',
    preflightToastTitle: '書き出し登録に失敗',
    preflightToastBody:
      '{reason}\n\n「Mockup / レイヤー」で各デバイスレイヤーの表示時間が書き出し時刻を含むか、ロックされていないか、デバイステンプレートが有効かを確認してから再試行してください。',
  },
  inspectorProject: {
    title: 'プロジェクト操作',
    save: 'プロジェクトを保存',
    load: 'プロジェクトを読み込み',
    reset: 'プロジェクトをリセット',
  },
  inspector: {
    controls: {
      panelLabel: 'Mockup コントロール',
      selectionInfo: '選択情報',
      operations: 'Mockup 操作',
      pleaseSelectFirst: '先に Mockup を選択してください',
      layerName: 'レイヤー名',
      device: 'デバイス',
      deviceTemplateAria: 'このレイヤーのデバイステンプレート',
      position: '位置',
      rotation: '回転 (度)',
      scale: 'スケール',
      axisPosition: '位置 {axis}',
      axisRotate: '回転 {axis}',
      axisScale: 'スケール {axis}',
      animationClip: 'アニメーションクリップ',
      clipEasing: 'クリップイージング',
      clipEasingAria: 'クリップのイージングプリセット（先頭フレームから末尾フレーム）',
      clipHint: '各クリップは先頭と末尾の 2 キーフレームのみです。変形編集前に再生ヘッドを端点または空白へ移動してください。',
      keyframesAria: 'クリップ端点',
      firstFrame: '先頭フレーム',
      lastFrame: '末尾フレーム',
      materialName: 'マテリアル名',
      noMaterial: 'スクリーンマテリアル未設定',
      selectMaterialFile: 'マテリアルファイルを選択',
      videoTextureAria: '動画スクリーンテクスチャ',
      videoFollowsTimeline: '動画はタイムラインに自動同期します。',
      timeOffsetSec: '時間オフセット（秒）',
      resetPosition: '位置をリセット',
      removeAnimation: 'アニメーションを削除',
      removeMockup: 'Mockup を削除',
      copyKeyframePose: 'キーフレームをコピー',
      pasteKeyframePose: 'キーフレームを貼り付け',
      easingLinear: 'リニア',
      easingEaseIn: 'イーズイン',
      easingEaseOut: 'イーズアウト',
      easingEaseInOut: 'イーズインアウト',
      easingBounceOut: 'バウンスアウト',
      easingBackOut: 'バックアウト',
      lockHint:
        'このレイヤーはロックされています。削除/複製は可能ですが、プロパティ編集とタイムライン編集はできません。',
      imagePlaneUpload: '画像 / 動画ファイルを選択',
      imagePlaneHint: 'アップロード後、プレーンは元のアスペクト比に自動調整されます。',
      textContent: 'テキスト内容',
      textFontSize: 'フォントサイズ（px）',
      textFontWeight: 'フォントの太さ',
      textFontWeightNormal: '標準',
      textFontWeightBold: '太字',
      textAlign: '文字揃え',
      textAlignLeft: '左寄せ',
      textAlignCenter: '中央揃え',
      textAlignRight: '右寄せ',
      textColor: 'テキストカラー',
      textPlaneHint: 'システムデフォルトフォントを使用し、改行に対応します。カスタムフォントは未対応です。',
      materialOpacityLabel: 'マテリアル不透明度',
      materialOpacitySliderAria: '選択中キーフレームのマテリアル不透明度。0 で完全透明、1 で不透明',
      materialOpacityValue: '現在値：{value}',
      screenImageStackHint:
        '静止画を複数枚アップロードできます（最大 {max} 枚、長辺最大 {edge}px）。タイムラインのキーフレームで表示を切り替えられます。',
      screenImageListAria: 'スクリーン画像リスト',
      screenImageRemove: '削除',
      keyframeScreenImage: 'このキーフレームのスクリーン画像',
      keyframeScreenImageInherit: '継承（先頭の画像）',
      overwriteVideoWithImagesTitle: '複数画像に切り替えますか？',
      overwriteVideoWithImagesBody:
        '現在の動画を削除し、選択した静止画に置き換えます。以降はキーフレームで画像を切り替えられます。',
      overwriteImagesWithVideoTitle: '動画に切り替えますか？',
      overwriteImagesWithVideoBody: 'すべてのスクリーン画像を削除し、選択した動画に置き換えます。',
      screenMediaOverwriteConfirm: '置き換える',
      screenMediaOverwriteCancel: 'キャンセル',
      screenImageOversize: '画像の幅・高さはそれぞれ {max}px 以下にしてください（このファイルは {w}×{h}）。',
      screenImageGifRejected: 'GIF は未対応です。PNG / JPEG / WebP をご利用ください。',
      screenImageLoadFailed: '画像を読み込めませんでした。',
      screenImageMaxCount: 'スクリーン画像は最大 {max} 枚までです。あと {room} 枚追加できます。',
      screenRasterTransition: '複数画像の切り替えトランジション',
      screenRasterTransitionAria:
        'タイムラインでスタック画像を切り替える際の GPU トランジション（セッション設定。次回の切り替えから有効）',
      screenRasterTransitionNone: 'なし（瞬時）',
      screenRasterTransitionFade: 'クロスフェード',
      screenRasterTransitionSlideLeft: '左スライド',
      screenRasterTransitionSlideRight: '右スライド',
      screenRasterTransitionSlideUp: '上スライド',
      screenRasterTransitionSlideDown: '下スライド',
      screenRasterTransitionZoom: 'ズーム',
      screenRasterTransitionCircle: '円形ワイプ',
    },
  },
  auth: {
    loginTab: 'ログイン',
    registerTab: '新規登録',
    loginTitle: 'メールでログイン',
    registerTitle: 'メールで登録',
    forgotTitle: 'パスワード再設定',
    tabsAria: '認証モードの切り替え',
    close: 'ログインダイアログを閉じる',
    email: 'メール',
    code: '確認コード',
    password: 'パスワード',
    newPassword: '新しいパスワード',
    sendCode: 'コードを送信',
    submitting: '送信中...',
    submitLogin: 'ログイン',
    submitRegister: '登録',
    submitForgot: 'パスワードを再設定',
    emailInvalid: '有効なメールアドレスを入力してください',
    emailMissingForSendCode: 'メールアドレスを入力してください',
    codeSent: '確認コードを送信しました。受信トレイをご確認ください',
    loginSuccess: 'ログインしました',
    registerSuccess: '登録が完了しました。ログインしてください',
    noAccount: 'アカウントをお持ちでないですか？',
    goRegister: 'アカウント登録',
    requestFailed: 'リクエストに失敗しました。しばらくしてから再試行してください',
    sendCodeRateLimited: '操作が多すぎます。しばらくしてから再試行してください',
    invalidCode: '確認コードが無効か期限切れです',
    emailRegistered: 'このメールは既に登録されています',
    userNotFound: 'アカウントが見つかりません。先に登録してください',
    passwordInvalid: 'パスワードが正しくありません',
    passwordTooShort: 'パスワードは 6 文字以上にしてください',
    forgotPassword: 'パスワードを忘れた場合',
    backToLoginPrefix: 'パスワードを思い出しましたか？',
    backToLogin: 'ログインに戻る',
    resetCodeSent: '再設定用コードを送信しました。受信トレイをご確認ください',
    resetSuccess: 'パスワードを更新しました。ログインしてください',
    showPassword: 'パスワードを表示',
    hidePassword: 'パスワードを隠す',
    passwordRuleHint: '8 文字以上で、大文字・小文字・数字・記号を含めることを推奨します',
    strengthWeak: '弱い',
    strengthMedium: '普通',
    strengthStrong: '強い',
    forgotStepHint: 'メールを入力してコードを取得し、新しいパスワードを設定してください。',
    testFillRequired: '必須項目を入力してください（テストモードでは形式チェックを省略します）',
    captchaRequired: 'まずボット対策を完了してください',
    captchaCancelled: 'ボット対策をキャンセルしました',
    cooldownSeconds: '__N__秒',
    rememberMe: 'パスワードを記憶',
    rememberDaysLabel: 'パスワードレスでログイン',
    rememberDaysTpl: '__DAYS__日間',
    googleDivider: 'または次の方法で続行',
    githubButton: 'GitHub で続行',
    wechatButton: 'WeChat で続行',
    wechatPopupTitle: 'WeChat ログイン',
    captcha: {
      title: 'ボット対策',
      tipPrefix: '次の順にクリック：',
      refresh: '別の画像',
      undo: '戻す',
      confirm: '確定',
      close: 'ボット対策を閉じる',
      loading: '読み込み中...',
      stageAlt: '表示された文字を順にクリック',
      loadError: '読み込みに失敗しました。「別の画像」で再試行してください',
    },
    profile: {
      title: 'アカウント',
      close: 'アカウントダイアログを閉じる',
      emailLabel: 'メール',
      subscriptionLabel: 'サブスクリプション',
      subscribed: '有効',
      notSubscribed: '未契約',
      subscribeNow: '購読する',
      details: '詳細',
      detailsTitle: 'サブスクリプション詳細',
      subscriptionSectionTitle: 'ステータス',
      ordersSectionTitle: '注文履歴',
      currentTier: '現在のプラン',
      expiresLabel: '有効期限',
      expiresAt: '期限：{date}',
      permanent: '永久',
      currentPeriod: '現在の期間',
      nextBilling: '次回請求',
      renewal: '更新設定',
      cancelAtPeriodEnd: '期間終了で解約',
      refresh: '更新',
      loading: '読み込み中...',
      totalTpl: '全 {n} 件',
      emptyOrders: '注文履歴はありません',
      prevPage: '前へ',
      nextPage: '次へ',
      pageTpl: '{p} ページ',
      pagerAria: '注文履歴のページ切り替え',
      orderNoLabel: '注文番号',
      payChannelLabel: '決済方法',
      payStatusLabel: '注文ステータス',
      payTimeLabel: '決済日時',
      productLabel: '購入内容',
      unknown: '—',
      orderPayStatus: {
        pending: '保留中',
        pe: '支払い完了',
        paid: '支払い完了',
        closed: 'クローズ',
        refunded: '返金済み',
      },
      orderType: {
        one_time: '単発購入',
        subscription: 'サブスク購入',
      },
      cancelSubscription: 'サブスクを解約',
      cancelling: '処理中...',
      cancelConfirmTitle: '解約しますか？',
      cancelConfirmBody:
        '確認すると自動更新が停止されます。現在の期間が終了するまで特典は引き続き利用できます。',
      confirm: '確認',
      cancel: 'キャンセル',
      cancelSuccess: 'サブスクリプションを更新しました',
      queryUnavailable: 'サブスクリプション詳細を取得できません',
      proxyNonJson:
        'レスポンスが JSON ではありません（HTML のエラーページの可能性）。本番では VITE_MARKETING_ORIGIN をマーケティングサイトのオリジンに設定し、Nitro の /api プロキシに到達させてください。',
      proxyHtml404:
        '404 かつ HTML は多くの場合、Nuxt に届いていません（静的ホストのみ等）。VITE_MARKETING_ORIGIN の設定と /api の Nitro へのリバースプロキシを確認してください。',
      proxyHttpError: 'リクエストに失敗しました（HTTP {status}）',
      tier: {
        none: '未契約',
        monthly: '月額',
        yearly: '年額',
        lifetime: '永久',
      },
      subStatus: {
        pending: '保留中',
        trialing: 'トライアル',
        active: '有効',
        past_due: '支払い失敗',
        paused: '一時停止',
        cancelled: '解約済み',
        expired: '期限切れ',
        unknown: 'サブスクリプション情報を取得できません。会員資格は引き続き有効です。「再取得」をクリックしてください。',
      },
      createdLabel: '登録日',
      createdUnknown: '—',
      logout: 'ログアウト',
      avatarAria: 'アバター：{email} の頭文字 {initial}',
    },
  },
  editorActions: {
    rename: '名前を変更',
    switchTemplate: 'デバイステンプレートを切り替え',
    editPosition: '位置を編集',
    editRotation: '回転を編集',
    editScale: 'スケールを編集',
    editScreenMaterial: 'スクリーンマテリアルを編集',
    resetTransform: '変形をリセット',
    removeClip: 'アニメーションクリップを削除',
    addClip: 'アニメーションクリップを追加',
    pasteKeyframePose: 'キーフレーム姿勢を貼り付け',
    editClipEasing: 'クリップイージングを編集',
    editTimelineClip: 'タイムラインクリップを編集',
    useViewportTransformTool: 'ビューポート変換ツールを使用',
    editTextContent: 'テキスト内容を編集',
    editTextFontSize: 'フォントサイズを編集',
    editTextColor: 'テキストカラーを編集',
    editTextFontWeight: 'フォントの太さを編集',
    editTextAlign: '文字揃えを編集',
    editKeyframeMaterialOpacity: 'キーフレームのマテリアル不透明度を調整',
    editKeyframeScreenImage: 'キーフレームのスクリーン画像を設定',
  },
  editorMessages: {
    lockedCannot: 'レイヤーがロックされているため、{action}できません。',
    playheadOutsideVisibilityWindow:
      '再生ヘッドが可視区間外のため、アニメーションクリップを追加できません。',
    visibilityWindowTooShortForClip: '可視区間が 1 秒未満のため、アニメーションクリップを追加できません。',
    noGapInsideVisibilityWindow:
      '可視区間内にクリップを追加できる十分な空きがありません（最小 1 秒）。',
    viewportDropNoLayerHit: '画面貼り替えのため、モデル表面にファイルをドロップしてください。',
    viewportDropInvalidFile:
      '利用可能な画像・HDR・MP4 がありません（インスペクタのファイル選択と同じ条件です）。',
    viewportDropTextPlaneNotSupported:
      'テキストレイヤーは画面テクスチャのドロップに対応していません。インスペクタで編集してください。',
    screenVideoWebCodecUnsupported:
      'この動画は画面テクスチャに使えません。ブラウザが映像コーデックをデコードできません（MPEG-4 Part 2 など）。H.264（AVC）映像＋AAC 音声の MP4 に再エンコードしてからアップロードしてください。',
  },
} as const

export default jaJP
